import React from 'react'
import './CornerPlus.css'
export default function CornerPlus() {
  return (
        <div className="corner-plus"> 
            <span /> <span /> 
        </div> 
  )
}